'use strict';

import {Pipe, PipeTransform} from "@angular/core";
import {Tools} from "linkurious-shared";

@Pipe({name: 'truncate'})
export class TruncatePipe implements PipeTransform {
  transform(value: any, position: 'middle'|'end', limit: number): string {
    return TruncatePipe.truncate(value, position, limit);
  }

  /**
   * Process the truncation
   */
  public static truncate(value: any, position: 'middle'|'end', limit: number): string {
    let suffix = '\u2026';
    if ( !Tools.isDefined(value) ) {
      return value;
    }
    let valueToTruncate = `${value}`;
    if ( valueToTruncate.length <= limit + 1 ) {
      return valueToTruncate;
    }

    switch(position) {
      case 'middle' :
        return valueToTruncate.substring(
          0,
          Math.ceil(limit / 2)) + suffix + valueToTruncate.substring(valueToTruncate.length - Math.floor(limit / 2)
        );

      case 'end' :
        return valueToTruncate.substring(0, limit) + suffix;
    }
  }
}
